<template>
    <div class="section">
        <div class="columns">
            <div class="column is-6">
                <app-search-bar
                    v-model="searchValue"
                    class="lb-media-search-bar"
                />
            </div>
        </div>
        <div v-if="loading" class="columns is-multiline is-mobile">
            <div
                v-for="i in 20"
                :key="i"
                class="column is-12-mobile is-6-tablet is-4-desktop is-3-widescreen"
            >
                <div class="lb-project-box is-loading" />
            </div>
        </div>

        <div v-else class="columns is-multiline is-mobile">
            <router-link
                v-for="community in filteredCommunities"
                :key="community._id"
                :event="community.accessLevel == 'read' ? '' : 'click'"
                :to="{
                    name: 'community',
                    params: { communityId: community._id },
                }"
                class="column is-12-mobile is-6-tablet is-4-desktop is-3-widescreen"
            >
                <community-card
                    :content="community"
                    @click="$emit('click', community)"
                />
            </router-link>
        </div>
    </div>
</template>

<script>
import AppSearchBar from '@/components/AppSearchBar';
import CommunityCard from '@/components/CommunityCard';
import { Document } from 'flexsearch';
import _ from 'underscore';
export default {
    components: {
        CommunityCard,
        AppSearchBar,
    },
    props: {
        communities: {
            type: Array,
            required: true,
            default() {
                return [];
            },
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            searchValue: null,
            searchIndex: null,
        };
    },
    computed: {
        filteredCommunities() {
            if (this.searchValue) {
                let items;
                items = this.communities;
                this.searchIndex.remove(this.communities);
                this.searchIndex.add(items);
                const result = this.searchIndex.search(this.searchValue);
                const ids = _.chain(result).pluck('result').flatten().value();
                return this.communities.filter((item) => {
                    return _.contains(ids, item._id);
                });

                //return this.searchIndex.search(this.searchValue);
            }
            return this.communities;
        },
    },
    watch: {
        communities() {
            this.communities.forEach((item) => {
                this.searchIndex.add(item);
            });
        },
    },
    beforeMount() {
        this.searchIndex = new Document({
            resolution: 3,
            tokenize: 'full',
            document: {
                id: '_id',
                index: ['title', 'description', 'tags'],
            },
        })
    },
};
</script>

<style scoped>
.lb-project-search-bar {
    border: 1px solid #d8d8d8;
    border-radius: 9999px;
}
</style>
